export function groupCoachNotes(notes) {
  const groups = new Map();
  for (const note of notes) {
    const key = note.rootNoteId || note.id;
    if (!groups.has(key)) groups.set(key, { key, notes: [], latest: note });
    const group = groups.get(key);
    group.notes.push(note);
    if (new Date(note.createdAt) > new Date(group.latest.createdAt) || (note.createdAt === group.latest.createdAt && note.id > group.latest.id)) group.latest = note;
  }
  return [...groups.values()];
}

export function isCoachOverdue(note, now = Date.now()) {
  const dueAt = note.rootSettings?.coachDueAt || note.metadataJson?.coachDueAt;
  return note.status !== "resolved" && Boolean(dueAt) && new Date(dueAt).getTime() < now;
}
